import { useLayoutEffect, useRef } from 'react';
import company from '../../../assets/images/icons/company.svg';
import employeeIconSvg from '../../../assets/images/icons/employee.svg';
import greenCompany from '../../../assets/images/icons/greenCompany.svg';
import OpacityAnimation from '../../../components/OpacityAnimation';
import floatToCurrency from '../../../utils/floatToCurrency';
import { CoordType, DataByEmployeeType } from '../types';

interface DisplayLtsMapInterface {
  data: DataByEmployeeType[]
}

export default function DisplayLtsMap({ data }: DisplayLtsMapInterface) {
  const mapRef = useRef(null);

  useLayoutEffect(() => {
    if (data.length === 0) {
      return undefined;
    }
    const currentLocTrab = {
      lat: data[0].employee.currentLtLat,
      lng: data[0].employee.currentLtLng,
      name: data[0].employee.currentLtName,
    };
    const employee = {
      lat: data[0].employee.lat,
      lng: data[0].employee.lng,
      name: data[0].employee.currentLtName,
      vt: data[0].employee.vt,
      cpf: `•••.•••.${data[0].employee.cpf?.slice(8, 16)}`,
      matricula: data[0].employee.matricula,
    };
    const indicatedsLocTrabs = data.map((i) => (
      {
        lat: i.indicatedsLts.lat,
        lng: i.indicatedsLts.lng,
        name: i.indicatedsLts.name,
        vt: i.indicatedsLts.vt,
      }
    ));

    if (!mapRef.current) return undefined;

    const currentEmployeeCoords = { lat: employee.lat, lng: employee.lng };
    const { H } = window;
    const platform = new H.service.Platform({
      apikey: process.env.REACT_APP_HERE_KEY,
    });
    const defaultLayers = platform.createDefaultLayers();
    // Create an instance of the map
    const mapInstance = new H.Map(
      mapRef.current,
      defaultLayers.vector.normal.map,
      {
        center: currentEmployeeCoords,
        zoom: 13,
        pixelRatio: window.devicePixelRatio || 1,
      },
    );
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(mapInstance));
    const ui = H.ui.UI.createDefault(mapInstance, defaultLayers);

    function addMarkersToMap(map: any) {
      const currentLtIcon = new H.map.Icon(company);
      const currentLtCoords = { lat: currentLocTrab.lat, lng: currentLocTrab.lng };
      // const currentLtName = currentLocTrab.name;
      const currentLtMarker = new H.map.Marker(currentLtCoords, { icon: currentLtIcon });
      map.addObject(currentLtMarker);

      const employeeIcon = new H.map.Icon(employeeIconSvg);
      const employeeCoords = { lat: employee.lat, lng: employee.lng };
      // const employeeName = employee.name;
      const employeeMarker = new H.map.Marker(employeeCoords, { icon: employeeIcon });
      map.addObject(employeeMarker);

      indicatedsLocTrabs.forEach((lti) => {
        const ltiIcon = new H.map.Icon(greenCompany);
        const ltiCoord = { lat: lti.lat, lng: lti.lng };
        const ltiName = lti.name;
        const ltiMarker = new H.map.Marker(ltiCoord, { icon: ltiIcon });

        function addMarkerToGroup(group: any, coordinate: CoordType, html: string) {
          const marker = new H.map.Marker(coordinate, { icon: ltiIcon });
          // add custom data to the marker
          marker.setData(html);
          group.addObject(marker);
        }

        function addInfoBubble(mp: any) {
          const group = new H.map.Group();
          mp.addObject(group);

          // add 'tap' event listener, that opens info bubble, to the group
          group.addEventListener('tap', (evt: any) => {
            // event target is the marker itself, group is a parent event target
            // for all objects that it contains
            const bubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
              // read custom data
              content: evt.target.getData(),
            });
              // show info bubble
            ui.addBubble(bubble);
          }, false);

          addMarkerToGroup(
            group,
            ltiCoord,
            `<div style="
                min-inline-size: max-content;
            ">
              ${ltiName}
              <br>
              VT Para este local: ${floatToCurrency(lti.vt)}
              <br>
              Economia: ${floatToCurrency(employee.vt - lti.vt)}
            </div>`,
          );
        }
        map.addObject(ltiMarker);
        addInfoBubble(map);
      });
    }

    addMarkersToMap(mapInstance);

    return () => {
      mapInstance.dispose();
    };
  }, [data, mapRef]);

  return (
    <OpacityAnimation delay={0.5}>
      <div ref={mapRef} style={{ height: '500px', width: '100%' }} />
    </OpacityAnimation>
  );
}
